// extracted by mini-css-extract-plugin
export default {"wixelIcon":"pOatDd"};